import React from 'react';
export function ObjectionsSection() {
  return <section className="py-6 text-gray-800" data-id="element-34">
      <h2 className="text-2xl font-bold mb-6 text-center" data-id="element-35">
        But What If You're Thinking...
      </h2>
      <div className="mb-8" data-id="element-36">
        <h3 className="text-xl font-bold mb-3" data-id="element-37">
          "I've Tried Everything Already"
        </h3>
        <p className="mb-6 leading-relaxed" data-id="element-38">
          Linda said the same thing. But here's what she learned: she hadn't
          tried THIS combination.
        </p>
        <p className="mb-6 leading-relaxed italic" data-id="element-39">
          "I'd used heating pads, tried compression sleeves, even had massage
          therapy," Linda explains. "But I'd never experienced all four working
          together. The difference is incredible."
        </p>
        <p className="mb-6 leading-relaxed" data-id="element-40">
          This isn't another single-solution gimmick. It's comprehensive therapy
          that addresses knee pain from multiple angles simultaneously.
        </p>
      </div>
      <div className="mb-8" data-id="element-41">
        <h3 className="text-xl font-bold mb-3" data-id="element-42">
          "It Sounds Too Good to Be True"
        </h3>
        <p className="mb-6 leading-relaxed" data-id="element-43">
          Linda was skeptical too. "After years of disappointment, I'd become
          pretty cynical," she admits.
        </p>
        <p className="mb-6 leading-relaxed" data-id="element-44">
          That's why the company offers a 90-day money-back guarantee. If it
          doesn't work for you like it worked for Linda and thousands of other
          women, you get every penny back.
        </p>
        <p className="mb-6 leading-relaxed italic" data-id="element-45">
          "I figured I could try it risk-free," Linda says. "And honestly, after
          spending thousands on treatments that didn't work, what did I have to
          lose?"
        </p>
      </div>
      <div className="mb-8" data-id="element-46">
        <h3 className="text-xl font-bold mb-3" data-id="element-47">"What About the Cost?"</h3>
        <p className="mb-4 leading-relaxed" data-id="element-48">
          Linda calculated that her device paid for itself in less than one
          month:
        </p>
        <ul className="list-disc pl-8 mb-6 space-y-2" data-id="element-49">
          <li data-id="element-50">Monthly pain medications: $200</li>
          <li data-id="element-51">Physical therapy sessions: $180 each</li>
          <li data-id="element-52">Doctor visits: $150+ each</li>
          <li data-id="element-53">Device cost: One-time payment of $149</li>
        </ul>
        <p className="mb-6 leading-relaxed italic" data-id="element-54">
          "In just the money I saved on pills, this device paid for itself in
          three weeks," Linda explains. "And I've been using it for eight months
          now. The value is incredible."
        </p>
      </div>
      <div className="mb-8" data-id="element-55">
        <h3 className="text-xl font-bold mb-3" data-id="element-56">"Is It Safe?"</h3>
        <p className="mb-6 leading-relaxed" data-id="element-57">
          Linda checked with her doctor before using the device (though she
          admits she was prepared to try it either way).
        </p>
        <p className="mb-6 leading-relaxed italic" data-id="element-58">
          "My doctor said there were no contraindications for me, and that the
          therapies were all standard treatments they recommend," Linda recalls.
        </p>
        <p className="mb-6 leading-relaxed" data-id="element-59">
          The device is FDA-registered, uses gentle therapy levels, and
          automatically shuts off after each session. It's designed for safe
          daily use.
        </p>
      </div>
      <div className="mb-8" data-id="element-60">
        <h3 className="text-xl font-bold mb-3" data-id="element-61">
          "Will It Work for My Specific Situation?"
        </h3>
        <p className="mb-6 leading-relaxed" data-id="element-62">
          Linda had severe osteoarthritis with bone-on-bone contact in her knee.
          If it worked for her, it can likely help you too.
        </p>
        <p className="mb-4 leading-relaxed" data-id="element-63">The device is designed for:</p>
        <ul className="list-disc pl-8 mb-6 space-y-2" data-id="element-64">
          <li data-id="element-65">Osteoarthritis and rheumatoid arthritis</li>
          <li data-id="element-66">General joint stiffness and soreness</li>
          <li data-id="element-67">Post-injury recovery</li>
          <li data-id="element-68">Chronic pain from old injuries</li>
          <li data-id="element-69">Prevention of future joint problems</li>
        </ul>
        <p className="mb-6 leading-relaxed italic" data-id="element-70">
          "I thought my case was hopeless," Linda says. "But this device proved
          me wrong."
        </p>
      </div>
      <div className="bg-red-100 p-6 rounded-lg mb-6" data-id="element-71">
        <h3 className="text-xl font-bold mb-3 text-center" data-id="element-72">
          Don't Make Linda's Mistake – Don't Wait
        </h3>
        <p className="mb-6 leading-relaxed" data-id="element-73">
          Linda's story has been shared thousands of times online, and demand
          for these devices has exploded.
        </p>
        <p className="mb-6 leading-relaxed" data-id="element-74">
          The manufacturer is struggling to keep up with orders, especially as
          more people discover this natural alternative to pills and surgery.
        </p>
        <p className="mb-6 leading-relaxed" data-id="element-75">
          Here's what Linda wants you to know:
        </p>
        <p className="mb-6 leading-relaxed italic" data-id="element-76">
          "I wish I'd found this device two years earlier. I lost so much time
          being in pain, missing out on life, when the solution was available
          all along.
        </p>
        <p className="mb-6 leading-relaxed italic" data-id="element-77">
          Every day you wait is another day of unnecessary pain. Another day of
          missing moments with family. Another day of feeling older than you
          are."
        </p>
        <p className="mb-4 leading-relaxed" data-id="element-78">
          Consider what another month of knee pain costs you:
        </p>
        <ul className="list-disc pl-8 mb-6 space-y-2" data-id="element-79">
          <li data-id="element-80">$200+ in medications that don't solve the problem</li>
          <li data-id="element-81">Missed activities and experiences</li>
          <li data-id="element-82">Continued deterioration of your joint health</li>
          <li data-id="element-83">The emotional toll of daily discomfort</li>
        </ul>
        <p className="mb-6 leading-relaxed font-bold text-center" data-id="element-84">
          "Don't make my mistake of waiting," Linda urges. "The sooner you
          start, the sooner you can get your life back."
        </p>
      </div>
    </section>;
}